module.exports = __webpack_public_path__ + "static/media/14_1.4bb5a5ed.jpg";